module.exports = __webpack_public_path__ + "img/slika36.c99bf73a.jpg";